__turbopack_context__.v({
  "className": "playfair_display_fcde36b6-module__0oWfya__className",
  "variable": "playfair_display_fcde36b6-module__0oWfya__variable",
});
